// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types'
import classnames from 'classnames';
import styled from 'styled-components';
import Button from '../common/components/button/Button';
import Select from '../common/components/select/Select';
import TextInput from '../common/components/textinput/TextInput';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
import withLocalized from '../localization/withLocalized';
import { VoucherField } from "./components/VoucherField";

const StyledFieldset = styled.fieldset`
  margin-bottom: 1rem;
`;

class BookingForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.array.isRequired,
    errors: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    submitLabel: PropTypes.string.isRequired,
    shouldFocusFirstField: PropTypes.bool,
  };

  static defaultProps = {};

  mapFields = (fields:Array<any>) => {
    const { localized } = this.props;

    const formFields = fields.map((field, index) => {
      const fieldProps = omitBy({
        key: field.key,
        name: field.key,
        tabIndex: index+1,
        autoFocus: index === 0 && this.props.shouldFocusFirstField ? 'autofocus' : undefined,
        type: field.inputType || undefined,
        autoComplete: field.autoComplete || undefined,
        min: field.inputMin !== undefined ? field.inputMin : undefined,
        max: field.inputMax !== undefined ? field.inputMax : undefined,
      }, isUndefined);
      switch (field.fieldType) {
        case 'input':
          return (
            <TextInput {...fieldProps} placeholder={localized(field.label)} />
          );
        case 'select':
          return (
            <Select {...fieldProps} defaultValue=''>
              {field.label && <option value="" disabled>{localized(field.label)}</option>}
              {field.options.map((option) => {
                return (
                  <option key={option.key} value={option.key}>{localized(option.label)}</option>
                );
              })}
            </Select>
          );
        case 'voucher':
          return (
            <VoucherField {...field.props}/>
          );
        default:
          return null;
      }
    });

    return formFields;
  }

  resolveClassName = (elementName:string) => {
    const classNames = classnames({
      'error': this.props.errors[elementName] !== undefined,
      'touched': this.props.touchedFields.indexOf(elementName) > -1
    })
    return classNames;
  };

  renderFields() {
    const fields = this.mapFields(this.props.fields);
    const childrenWithProps = React.Children.map(fields,
     (child) => React.cloneElement(child, {
       className: this.resolveClassName(child.key),
       errors: this.props.errors[child.key],
       onChange: this.props.onChange
     })
    );
    return childrenWithProps;
  }

  render() {
    const { onSubmit, disabled, submitLabel, children } = this.props;
    
    return (
      <form
        onSubmit={onSubmit}
        autoComplete="off"
        autoCorrect="off"
        noValidate
        spellCheck="false"
      >
        <StyledFieldset>
          {this.renderFields()}
          {children}
        </StyledFieldset>
        <Button block type="submit" disabled={disabled}>{submitLabel}</Button>
      </form>
    );
  }
}

export default withLocalized(BookingForm);



// WEBPACK FOOTER //
// ./src/modules/booking/BookingForm.js